import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import FancySelect from '../elements/FancySelect/FancySelect'
import SearchBar from '../elements/SearchBar'
import Pagination from '../components/Pagination'
import PropTypes from 'prop-types'
import ReportIncorrect from '../components/ReportIncorrect'
import LoadingOverlay from '../components/LoadingOverlay'

class HomeSecureLog extends React.Component {
    constructor (props) {
        super(props)

        const today = new Date()
        this.months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }

        this.state = {
            isLoaded: false,
            hasError: false,
            isLoadingBreakdown: false,
            transactions: [],
            paginatedResults: [],
            page: 1,
            pageCount: 0,
            resultQty: 25,
            search: '',
            month: this.months[today.getMonth() + 1],
            year: today.getFullYear()
        }
    }

    componentDidMount () {
        this.getData()
    }

    getData () {
        this.setState({ isLoadingBreakdown: true })
        DataSource.getData(`/api/getBlockingLogs/${this.props.serviceId}/${this.state.month}/${this.state.year}`, result => {
            if (result) {
                result.sort(this.sortDates.bind(this))
                const rows = []
                result.forEach(item => {
                    rows.push([
                        item.blockTime,
                        item.blockType,
                        `<span title="${item.blockName}">${this.truncateName(item.blockName)}</span>`
                        // <ReportIncorrect blockName={this.truncateName(item.blockName)} blockType={item.blockType} />
                    ])
                })

                this.setState({
                    transactions: rows,
                    paginatedResults: this.paginateResults(rows)
                }, () => {
                    this.setPageNumber(rows)
                    this.setState({ isLoaded: true, isLoadingBreakdown: false })
                })
            } else {
                this.setState({ isLoaded: true, isLoadingBreakdown: false })
            }
        }, () => {
            this.setState({ hasError: true, isLoaded: true, isLoadingBreakdown: false })
        })
    }

    sortDates (a, b) {
        if (a.blockTime < b.blockTime) return 1
        if (a.blockTime > b.blockTime) return -1

        return 0
    }

    setResults (results) {
        this.setState({
            paginatedResults: this.paginateResults(results)
        }, () => {
            this.setPageNumber(results)
            this.setState({ isLoadingBreakdown: false })
        })
    }

    setPageNumber (results) {
        this.setState({
            pageCount: Math.max(1, Math.ceil(results.length / this.state.resultQty))
        })
    }

    setResultQty (qty) {
        this.setState({ resultQty: qty }, () => {
            if (this.state.search.length > 0) {
                this.updateSearchResults()
            } else {
                this.setState({ isLoadingBreakdown: true })
                this.resetPage()
                setTimeout(() => this.resetTransactions(), 200)
            }
        })
    }

    setSearch (event) {
        this.setState({ search: event.target.value }, () => {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.updateSearchResults()
            }, 500)
        })
    }

    resetTransactions () {
        this.setState({
            paginatedResults: this.paginateResults([...this.state.transactions])
        }, () => {
            this.setPageNumber(this.state.transactions)
            this.setState({ isLoadingBreakdown: false })
        })
    }

    resetPage () {
        this.setState({ page: 1 })
    }

    updateSearchResults (isPageChange = false) {
        this.setState({ isLoadingBreakdown: true })
        if (!isPageChange) {
            this.resetPage()
        }

        if (this.state.search.length > 0) {
            const results = []

            this.state.transactions.forEach(itemArr => {
                const found = itemArr.find(item => {
                    if (typeof item !== 'object') {
                        return item.includes(this.state.search)
                    }
                })

                if (found) {
                    results.push(itemArr)
                }
            })

            setTimeout(() => this.setResults(results), 200)
        } else {
            setTimeout(() => this.resetTransactions(), 200)
        }
    }

    paginateResults (results) {
        const start = parseInt((this.state.page - 1) * this.state.resultQty)
        const end = start + parseInt(this.state.resultQty)

        return results.slice(start, end)
    }

    handleChangePage (event) {
        event.preventDefault()
        const page = event.target.dataset.page
        this.setState({ isLoadingBreakdown: true })
        this.scrollToTop()

        setTimeout(() => {
            this.setState({ page: page }, () => this.updateSearchResults(true))
        }, 200)
    }

    handleChangeMonth (value) {
        if (value !== this.state.month) {
            this.setState({ month: value, search: '' }, this.getData.bind(this))
        }
    }

    handleChangeYear (value) {
        if (value !== this.state.year) {
            this.setState({ year: value, search: '' }, this.getData.bind(this))
        }
    }

    scrollToTop () {
        window.scrollTo(this.breakdown.offsetLeft, this.breakdown.offsetTop - 50)
    }

    yearData () {
        const years = []
        const today = new Date()
        const thisYear = today.getFullYear()

        for (let i = (thisYear - 10); i <= thisYear; i++) {
            years.push(i)
        }

        return years.reverse()
    };

    truncateName (blockName) {
        if (blockName.length > 50) {
            return `${blockName.substring(0, 50)}...`
        }

        return blockName
    };

    render () {
        const transactionData = {
            headings: ['Block time', 'Block type', 'Blocked URL / Virus Name'],
            rows: this.state.paginatedResults
        }

        const Results = () => {
            if (this.state.paginatedResults.length > 0) {
                return <ResponsiveTable data={transactionData} minWidthMobile={800} />
            } else {
                return (
                    <div className='row-error text-center mt-3'>
                        {this.state.search.length > 0 ? `No items match your search "${this.state.search}".` : 'No items to display'}
                    </div>
                )
            }
        }

        return (
            <div className='home-secure-log module'>
                <Heading title='Activity log' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='date-selection'>
                        <div className='row'>
                            <div className='col-12 col-md-6 form-control text-center text-md-left mb-0'>
                                <label>Select month to display</label>
                                <div>
                                    <FancySelect
                                        label='Month'
                                        list={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']}
                                        value={this.state.month}
                                        setValue={this.handleChangeMonth.bind(this)}
                                    />
                                    <FancySelect
                                        label='Year'
                                        list={this.yearData()}
                                        value={this.state.year}
                                        setValue={this.handleChangeYear.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <LoadingOverlay isLoading={this.state.isLoadingBreakdown}>
                        <div className='breakdown' ref={el => this.breakdown = el}>
                            <div className='row'>
                                <div className='col-12'>
                                    <h1 className='text-center'>Activity log breakdown</h1>
                                </div>
                            </div>
                            <div className='row mb-md-0 mb-5'>
                                <div className='col-12 col-md-6'>
                                    <div className='form-control d-none d-lg-flex'>
                                        <label>No. of entries to display <br /><small>(total {this.state.transactions.length})</small></label>
                                        <FancySelect
                                            list={[25, 50, 100]}
                                            value={this.state.resultQty}
                                            setValue={this.setResultQty.bind(this)}
                                        />
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 text-center text-lg-right'>
                                    <SearchBar handleChange={this.setSearch.bind(this)} />
                                </div>
                            </div>
                            {Results()}
                            <Pagination page={this.state.page} pageCount={this.state.pageCount} handleClick={this.handleChangePage.bind(this)} />
                        </div>
                    </LoadingOverlay>
                </ModuleWithLoader>
            </div>
        )
    }
}

HomeSecureLog.propTypes = {
    serviceId: PropTypes.number.isRequired
}

export default HomeSecureLog



// WEBPACK FOOTER //
// ./resources/js/modules/HomeSecureLog.js